import Single from '../components/Single/Single';

const ItemScreen = () => {
	return (
		<>
			<Single />
		</>
	);
};

export default ItemScreen;
